/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 5:09:00 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image } from "ui-widgets";
import pluralize from "pluralize";

interface EmptySearchResultsMessageProps {
  unit: string;
  searchText: string;
}

export const EmptySearchResultsMessage = ({ unit, searchText }: EmptySearchResultsMessageProps) => {
  return (
    <EmptyStateActionWrapper
      title={`No results found`}
      description={
        <>
          No {unit ? pluralize(unit) : "results"} were found for the search term <b>{searchText}</b>
        </>
      }
      illustrationGraphic={<Image src="/img/no-results.png" />}
    />
  );
};
